import http from "../requestBase";

const API_BASE =
  "api/SurveyInstanceAnswerHistory/SurveyInstancesAnswersHistory";

/**
 * @typedef {Object} HistoryQuestionRequest
 * @property {String[]} QuestionGuid - Array of guid to fetch the History for
 */

/**
 *
 * @param {number} id The SurveyInstanceId
 */
function getAnswersHistory(id) {
  return http.get(`${API_BASE}/${id}`);
}

const Hist = {
  getAnswersHistory,
};

export default Hist;



// WEBPACK FOOTER //
// ./src/services/SurveyInstances/SurveyAnswerHistory.js